export const environment = {
  requestEncryptKey: "FD6hVFC7r9kTVsE8Y0gui2GU8NrhFvGp",
  isDevelopment: false,

  // ! ---------- Development ------------
  // production: false,
  // baseUrl: "https://development.wiyakdelivery.com/wfleet/",
  // baseUrlVrooomOld: "https://development.wiyakdelivery.com/vroom/",
  // baseUrlVrooom: "https://vroom.wiyakdelivery.com/",
  // OSRMDockerUrl: "https://development.wiyakdelivery.com/openstreet/route/v1/driving/",
  // apiKey: "AIzaSyDqXmysQZM8pNUVcU7BWmLE2GutPVcO9vc", // wiyaktechsuperstar1@gmail.com ,
  // mqtt: {
  //   hostName: "mqtt.wiyak.com",
  //   path: "/mqtt",
  //   protocol: "wss",
  //   clean: true,
  //   connectTimeout: 4000,
  //   clientId: "dispatchermqtt_" + Math.random().toString(16).substr(2, 10),
  //   userName: "wiyakkuwait",
  //   password: "0C46507DF16A0B4B4A25FC7FCC1D47B7wiyakkuwait",
  //   reconnectPeriod: 1000,
  //   keepalive: 65535
  // },

  // ForceApiKey: "ulO66nVd8zfrgfY172J*4iD+fh7K4Q+ZzxBhNiT2ld-JE7f5FvzMe$NeF55Bk35bza6NobTny57wiHF#ISNKBQU!KKwQC%H=yiGVPGtM1NoG*DYMAiIPVL&amp;9v$vO14SK",
  // encryptSecretKey: "40770da6eaeb1d7e442f8b483fb49e088e72dc5113cb69637510553697035930",
  // leafletMapKey: "pk.eyJ1IjoicmFrZXNodGlzIiwiYSI6ImNreHlhZHE0ajR3cXQydnF3MWJ5bmRoNnAifQ.Cy8QK8eNdoUA2_6mKJeslw",
  // deliveryProof: "https://development.wiyakdelivery.com/wfleet/" + "media/img/fetch/" + 'Proof/', //dev




  // ! ---------- Production ------------
  production: false,
  // baseUrl: "https://production.wiyak.online/wifleet/", //! Old
  // baseUrl: "https://api.wiyak.net/wifleet/", //! New
  baseUrl: "https://api-archive2.wiyak.net/wifleet/", //! archive 2
  // baseUrl: "https://api-archive1.wiyak.net/wifleet/", //! archive 1
  baseUrlVrooom: "https://development.wiyakdelivery.com/vroom/",
  OSRMDockerUrl: "https://development.wiyakdelivery.com/openstreet/route/v1/driving/",
  apiKey: "AIzaSyDqXmysQZM8pNUVcU7BWmLE2GutPVcO9vc", // wiyaktechsuperstar1@gmail.com 
  mqtt: {
    // hostName: "mqttwifleet.wiyak.online", //! Old
    hostName: "mqtt.wiyak.net", //! New
    path: "/mqtt",
    protocol: "wss",
    clean: true,
    connectTimeout: 4000,
    clientId: "wifleet_mqtt_" + Math.random().toString(16).substr(2, 10),
    userName: "WiFleet_prod",
    password: "LEJUwuJSMr6BYd1xoAH7Z60KjZImwmKCVhF32e0SNU2DQfYH4IxGLY",
    reconnectPeriod: 1000,
    keepalive: 65535
  },
  ForceApiKey: "oZpbFohfTmx49EQdq4kk739QkVzfJprDxNaaPIbth8pNCaL2dMwqtU6iZok4cNNRNPPU4pquQZkxZyM2B0F4SianEcXwxjJuV6P6X3tMe5ccmfhpJ6GsPCNJ9wy2pRi",
  encryptSecretKey: "40770da6eaeb1d7e442f8b483fb49e088e72dc5113cb69637510553697035930",
  leafletMapKey: "pk.eyJ1IjoicmFrZXNodGlzIiwiYSI6ImNreHlhZHE0ajR3cXQydnF3MWJ5bmRoNnAifQ.Cy8QK8eNdoUA2_6mKJeslw",
  // deliveryProof: "https://production.wiyak.online/wifleet/" + "media/img/fetch/" + 'Proof/', //prod Old,
  deliveryProof: "https://api.wiyak.net/wifleet/" + "media/img/fetch/" + 'Proof/', //prod New,


  shopifyUrl: 'https://onlinestore.wiyakdelivery.com',



  imageUrl: "media/img/fetch/",
  CompanySetting: "CompanySetting/",
  cars: "Car/",
  driver: "Driver/",
  DispatcherImg: "Dispatcher/",
  DispatcherCars: "DispatcherCars/",
  dashboardPageSplitterSize: {
    'dashboardMapPane': "65%",
    'dashboardTablePane': "35%",
  },
  taskDelayObject: {
    timerDuration: 60, // in second
    maxDelay: 'background-color: #ff0000; color: #ffffff;',  // red
    minDelay: 'background-color: #ff9c00; color: #ffffff;', // yellow
    aot: 'background-color: #00ff7e  ; color: #ffffff;', // green
    minAssignTime: -15,  // in minutes
  },
  devClipBoard: true,
  driverMarkerIcon: {
    height: 60,
    width: 60,
    labelOrigin: { x: 0, y: -5 },
    anchor: { x: 50, y: 19 }
  },
  routeOptimizeConfig: {
    driverSpeedForRouteOptimize: 42,
    serviceTimeForRouteOptimize: 10,
    seatCapacityForRouteOptimize: 10
  },
  vroomDriverSpeedFactor: 0.42,
  teamDriverLimit: 50,

  // permission object for application-wide permission handling
  appPermissions: {},

  defaultPermissions: {
    roleManagement: {
      roleView: true,
      roleCreate: true,
      roleEdit: true,
      roleAssign: true,
    },
    dashboard: {
      dashboardView: true,
      dashboardMapView: true,
    },
    analytics: {
      analyticsView: true,
      analyticsTaskExport: true,
      analyticsDriverTaskExport: true,
      taskAnalyticsView: true,
      driverAnalyticsView: true
    },
    taskManagement: {
      taskView: true,
      taskCreate: true,
      taskEdit: true,
      taskCancel: true,
      taskDelete: true,
      taskTrack: true,
      taskClone: true,
      taskAssign: true,
      taskBulkCreate: true,
      taskPrintLabel: true,
      taskPrintBriefLabel: true,
      taskPrintDetailedLabel: true,
      taskRouteOptimize: true,
      taskSnailTrack: true,
      taskSendWhatsappMessage: true,
      taskWhatsappChatHistory: true,
      taskPlan: true,
      taskDetailsShow: true,
      isShowReview: true,
      taskCommentBox: true,
    },
    driverManagement: {
      driverView: true,
      driverCreate: true,
      driverBulkCreate: true,
      driverEdit: true,
      driverRemove: true,
      driverOnlineOfflineAccess: true,
      driverVerificationAccess: true,
      driverShiftAssign: true,
      driverTaskAssign: true,
      driverDetailsShow: true,
      driverTaskPrioritySet: true,
      driverTaskExport: true
    },
    transactionManagement: {
      driverShowTransactionHistory: true,
      driverCollectAmount: true,
    },
    vehicleManagement: {
      vehicleView: true,
      vehicleCreate: true,
      vehicleEdit: true,
      vehicleRemove: true,
      vehicleAssignUnassignDrivers: true,
      vehicleHistoryReportExport: true,
      vehicleRoasterReportExport: true,
      vehicleRoasterActivitiesAccess: true,
      vehicleInActiveAccess: true,
    },
    shiftManagement: {
      shiftView: true,
      shiftReportExport: true,
    },
    routeManagement: {
      routeView: true,
      routeCreate: true,
      routeUnassignTour: true,
      routeAssignTour: true,
      routeReCalculate: true,
      routeTourDraft: true,
      planCalenderView: true,
      planRemove: true
    },
    boundaryZones: {
      boundaryZonesView: true,
      boundaryZonesCreate: true
    },
    branchManagement: {
      branchView: true,
      branchCreate: true,
      branchEdit: true,
      branchRemove: true
    },
    operationalZoneManagement: {
      operationalZoneView: true,
      operationalZoneCreate: true,
      operationalZoneImport: true
    },
    generalSettings: {
      settingsGeneralView: true,
      settingsGeneralEdit: true,
      settingsEmailView: true,
      settingsEmailEdit: true,
      settingsWhatsappMessageView: true,
      settingsWhatsappMessageEdit: true,
      settingsNotificationView: true,
      settingsNotificationEdit: true
    },
    userSettings: {
      userTeamsView: true,
      userTeamsCreate: true,
      userTeamsEdit: true,
      userTeamsRemove: true,
      userHubView: true,
      userHubCreate: true,
      userHubEdit: true,
      userHubRemove: true,
      userAdminView: true,
      userAdminCreate: true,
      userAdminEdit: true,
      userAdminRemove: true,
      userDispatcherView: true,
      userDispatcherCreate: true,
      userDispatcherEdit: true,
      userDispatcherRemove: true,
      userApiView: true,
      userApiCreate: true,
      userApiEdit: true,
      userApiRemove: true,
      userDriverShiftView: true,
      userDriverShiftCreate: true,
      userDriverShiftEdit: true,
      userDriverShiftRemove: true,
      userMainZoneView: true,
      userMainZoneCreate: true,
      userMainZoneEdit: true,
      userMainZoneRemove: true,
    },
    chatManagement: {
      chatAccess: true,
      taskChatDriver: true
    },
    wmsManagement: {
      wmsView: true,
    }

  }
}